<template>
<div>
  <b-card>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="sellinGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'sellinGrid',
  components: {
    Grid
  },
  data() {
    return {
      filters: {
        dsr: null,
        dsr_id: null
      },
      gridFilters: [{
        field:'dealer_id',
        modal:'dealers-modal',
        foreign: 'id',
        placeholder: 'Distribuidor'
      }, {
        field:'dsr_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'DSR'
      }, {
        field:'zone',
        modal:'zones-modal',
        foreign: 'zone',
        placeholder: 'Zona'
      }, {
        field:'prodaggreg_id',
        modal:'prodaggreg-modal',
        foreign: 'id',
        placeholder: 'Prodaggreg'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'date': {
          type: 'date'
        },
        'ym': {
          type: 'number'
        },
        'value': {
          type: 'number'
        },
        'turnover': {
          type: 'number'
        },
        'gsv': {
          type: 'number'
        },
        'quantity': {
          type: 'number'
        },
        'operator_id': {
          type: 'number'
        },
        'product_id': {
          type: 'number'
        },
        'prodaggreg_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      }],
      url: 'sales/sellin',
      columns: [{
        field: 'date',
        title: 'Data',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '160px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      },
      {
        field: 'ym',
        title: 'Ano / Mês',
        width: '120px'
      },
      {
        field: 'shipto',
        title: 'Shipto',
        width: '220px'
      },
      {
        field: 'soldto',
        title: 'Soldto',
        width: '220px'
      },
      {
        field: 'ufs_salesteam_code',
        title: 'Cod. Vendedor',
        width: '220px'
      },
      {
        field: 'ufs_salesteam_name',
        title: 'Vendedor',
        width: '220px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '220px'
      },
      {
        field: 'nif',
        title: 'NIF',
        width: '120px'
      },
      {
        field: 'operator_id',
        title: 'ID Operador',
        width: '120px'
      },
      {
        field: 'value',
        title: 'Valor',
        width: '120px'
      },
      {
        field: 'turnover',
        title: 'TO',
        width: '120px'
      },
      {
        field: 'gsv',
        title: 'GSV',
        width: '120px'
      },
      {
        field: 'quantity',
        title: 'Quantidade',
        width: '120px'
      },
      {
        field: 'sku',
        title: 'SKU',
        width: '120px'
      },
      {
        field: 'product_id',
        title: 'ID Produto',
        width: '120px'
      },
      {
        field: 'prodaggreg_id',
        title: 'ID Prodaggreg',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  }
}
</script>
